//
//
//
//

export default {
  props: {
    size: {
      type: Number,
      default: () => {
        return 32
      }
    }
  }
}
